export class LocaleInfo
{
    constructor(public locale:string,
                public englishName:string,
                public nativeName:string,
                public dateTimeFromat:string,
                public dateFromat:string,
                public timeFromat:string)
    {
    }
}

const englishUSA = new LocaleInfo(
    'en-us',
    'English(USA)',
    'English(USA)',
    'M/D/YYYY H:mm:ss',
    'M/D/YYYY',
    'h:mm:ss A'
);

export const CurrentLocale:LocaleInfo = englishUSA;
